module.exports = require("plugin-reports-maker/shared/SheduleAction");